import { HeaderInn } from "../components/HeaderInn"
import Navigation from "../components/Navigation"


export const Others = () => {


        return (
                <>
                        <HeaderInn purpose="other works" />
                        <Navigation />

                        <div>
                        
                        </div>

                </>
        )
}